jQuery( document ).ready( function ( $ ) {
	function ACCORDION( thisInstance ) {
		console.log( '[JTF Gut Block - JS] jtf/jtf-accordion v2.1' )
		this.instance = thisInstance
		this.init()
	}

	ACCORDION.prototype.init = function () {
		$( document ).on( 'click', '.jtf__accordionblock--trigger', function () {
			//console.log('jtf__accordionblock--trigger')
			let parent = $( this ).parent()

			parent.find( '.jtf__accordionblock__content' ).toggleClass( 'jtf__accordionblock__content-reveal' )
			parent.find( '.jtf__accordionblock--icon' ).toggleClass( 'fa-angle-down' )
			parent.find( '.jtf__accordionblock--icon' ).toggleClass( 'fa-angle-up' )

			var btn = $( this ).find( ":button" )
			btn.attr( 'aria-expanded' ) === 'true' ? btn.attr( 'aria-expanded', false ) : btn.attr( 'aria-expanded', true )

		} )
	}

	if ( $( '.wp-admin' ).length > 0 ) {
		setTimeout( function () {
			new ACCORDION( $( this ) )
		}, 1000 )
	} else {
		// wrap this in a check to see if the outer container even exists,
		// because that way we don't instntiate the code for this if its
		// not on the page
		if ( $( '.wp-block-jtf-jtf-accordion' ).length > 0 ) {
			new ACCORDION( $( this ) )
		}
	}
} )
